/**
 * Normaliza texto para busca em ng-select (acentos, ordinais, prefixos comuns de escola).
 * #179571 — evita “não localiza” quando o cadastro usa PROFA/STEFANO e a usuária digita Profª/Stéfano.
 */
export function normalizarTextoBusca(valor?: string | number | null): string {
  if (valor == null) {
    return '';
  }

  return String(valor)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\u00aa/gi, 'a') // ª
    .replace(/\u00ba/gi, 'o') // º
    .replace(/[^a-zA-Z0-9\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

const SINONIMOS_TOKEN: Record<string, string[]> = {
  profa: ['profa', 'professora', 'prof'],
  professora: ['profa', 'professora', 'prof'],
  prof: ['profa', 'professora', 'prof', 'professor'],
  professor: ['professor', 'prof'],
};

const TOKENS_IRRELEVANTES = new Set(['ee', 'e', 'escola', 'estadual', 'de', 'da', 'do', 'das', 'dos']);

function variantesToken(token: string): string[] {
  return SINONIMOS_TOKEN[token] ?? [token];
}

function tokenPresenteNoAlvo(token: string, alvo: string): boolean {
  return variantesToken(token).some((v) => alvo.includes(v));
}

/**
 * Busca por tokens (AND): cada palavra significativa do termo deve existir no rótulo,
 * tolerando ordem diferente (ex.: PROFA no fim do nome cadastro).
 */
export function textoContemBuscaNormalizada(
  textoAlvo?: string | number | null,
  termoDigitado?: string | null
): boolean {
  const termo = normalizarTextoBusca(termoDigitado);
  if (!termo) {
    return true;
  }

  const alvo = normalizarTextoBusca(textoAlvo);
  if (!alvo) {
    return false;
  }

  // Match direto (CIE completo, trecho contínuo)
  if (alvo.includes(termo)) {
    return true;
  }

  const tokens = termo
    .split(' ')
    .map((t) => t.trim())
    .filter((t) => t.length > 0 && !TOKENS_IRRELEVANTES.has(t));

  if (tokens.length === 0) {
    return alvo.includes(termo);
  }

  return tokens.every((token) => tokenPresenteNoAlvo(token, alvo));
}

/** searchFn compatível com ng-select (term, item). */
export function ngSelectSearchFnPorLabel(
  getLabel: (item: any) => string | number | null | undefined
): (term: string, item: any) => boolean {
  return (term: string, item: any) => textoContemBuscaNormalizada(getLabel(item), term);
}
